// src/components/LanguageSwitcher/LanguageSwitcher.tsx

import React, { useState, useRef, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { changeLanguage } from "../../i18n/i18n";
import "./LanguageSwitcher.scss";

interface Language {
    code: string;
    name: string;
}

const languages: Language[] = [
    { code: "pl", name: "Polski" },
    { code: "en", name: "English" },
];

const LanguageSwitcher: React.FC = () => {
    const { i18n, t } = useTranslation();
    const [isOpen, setIsOpen] = useState(false);
    const dropdownRef = useRef<HTMLDivElement>(null);

    // Znajdź aktualny język
    const currentLanguage = languages.find((lang) => lang.code === i18n.language) || languages[0];

    // Obsługa kliknięcia na przycisk języka
    const handleToggleDropdown = () => {
        setIsOpen(!isOpen);
    };

    // Obsługa zmiany języka
    const handleChangeLanguage = (langCode: string) => {
        changeLanguage(langCode);
        setIsOpen(false);
    };

    // Zamknięcie dropdown po kliknięciu poza nim
    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
                setIsOpen(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    return (
        <div className="language-switcher" ref={dropdownRef}>
            <button
                className="language-button"
                onClick={handleToggleDropdown}
                aria-expanded={isOpen}
                aria-label={t("common.language")}
            >
                <span className="language-code">{currentLanguage.code.toUpperCase()}</span>
                <span className="dropdown-arrow">{isOpen ? "▲" : "▼"}</span>
            </button>

            {isOpen && (
                <div className="language-dropdown">
                    {languages.map((language) => (
                        <button
                            key={language.code}
                            className={`language-option ${language.code === i18n.language ? "active" : ""}`}
                            onClick={() => handleChangeLanguage(language.code)}
                        >
                            <span className="language-code">{language.code.toUpperCase()}</span>
                            <span className="language-name">{language.name}</span>
                            {language.code === i18n.language && <span className="language-active">✓</span>}
                        </button>
                    ))}
                </div>
            )}
        </div>
    );
};

export default LanguageSwitcher;
